var _defs, _metadata;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 135.46667 135.46665",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.838893,93.664941)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.4666662)",
    id: "g4635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5051",
    style: {
      fill: "#5ea8a7",
      fillOpacity: 1
    },
    transform: "matrix(2.2577778,0,0,2.2577778,20.807042,-93.664949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5045",
    className: "",
    "data-original": "#3c7a84",
    d: "m 27,4 h 6 v 6 h -6 z",
    style: {
      fill: "#5ea8a7",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5047",
    className: "",
    "data-original": "#3c7a84",
    d: "m 10.332,18.57 -1.89,-1.889 a 1.5,1.5 0 0 1 0,-2.129 l 2.11,-2.11 a 1.5,1.5 0 0 1 2.129,0 l 1.889,1.89 z",
    style: {
      fill: "#5ea8a7",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5049",
    className: "",
    "data-original": "#3c7a84",
    d: "m 45.43,14.332 1.889,-1.89 a 1.5,1.5 0 0 1 2.129,0 l 2.11,2.11 a 1.5,1.5 0 0 1 0,2.129 l -1.89,1.889 z",
    style: {
      fill: "#5ea8a7",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "circle5053",
    className: "",
    "data-original": "#4c97a8",
    r: 56.444447,
    cy: -16.900503,
    cx: 88.540375,
    style: {
      fill: "#b7d9d8",
      fillOpacity: 1,
      strokeWidth: 2.25777769
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5055",
    className: "",
    "data-original": "#4c97a8",
    y: -91.407173,
    x: 77.251488,
    width: 22.577778,
    rx: 2.2577777,
    height: 9.0311108,
    style: {
      fill: "#b7d9d8",
      fillOpacity: 1,
      strokeWidth: 2.25777769
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle5057",
    className: "",
    "data-original": "#3e676d",
    r: 47.413334,
    cy: -16.900503,
    cx: 88.540375,
    style: {
      fill: "#5ea8a7",
      fillOpacity: 1,
      strokeWidth: 2.25777769
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5059",
    className: "",
    "data-original": "#ffffff",
    d: "M 113.37593,-40.607171 A 24.2824,24.2824 0 0 1 88.540376,-16.900504 24.2824,24.2824 0 0 0 63.70482,6.8061631 24.189831,24.189831 0 0 0 86.959932,30.467674 47.413334,47.413334 0 0 1 88.540376,-64.313838 c 0.519289,0 1.061156,0.02258 1.580444,0.04516 a 24.189831,24.189831 0 0 1 23.25511,23.661511 z",
    style: {
      fill: "#ff696b",
      fillOpacity: 1,
      strokeWidth: 2.25777769
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5061",
    className: "",
    "data-original": "#ffffff",
    d: "m 90.12082,-64.268682 c -0.519288,-0.02258 -1.061155,-0.04516 -1.580444,-0.04516",
    style: {
      fill: "#ffe6e6",
      strokeWidth: 2.25777769
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle5063",
    className: "",
    "data-original": "#3e676d",
    r: 5.6444445,
    cy: -40.60717,
    cx: 89.669266,
    style: {
      fill: "#5ea8a7",
      fillOpacity: 1,
      strokeWidth: 2.25777769
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle5065",
    className: "",
    "data-original": "#ffffff",
    r: 5.6444445,
    cy: 6.8061633,
    cx: 89.669266,
    style: {
      fill: "#ff696b",
      fillOpacity: 1,
      strokeWidth: 2.25777769
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5068",
    className: "",
    "data-original": "#373737",
    d: "m 88.540376,-66.571615 a 49.686916,49.686916 0 0 0 -32.173334,11.82624 2.2613243,2.2613243 0 0 0 2.935111,3.440853 45.155556,45.155556 0 0 1 29.238223,-10.751538 c 0.799253,0 1.580444,0.07902 2.366151,0.119662 A 21.923022,21.923022 0 0 1 111.11815,-40.607171 22.060747,22.060747 0 0 1 88.540376,-19.158282 26.576302,26.576302 0 0 0 61.447042,6.8061631 25.169707,25.169707 0 0 0 67.36242,22.956048 45.128463,45.128463 0 0 1 54.136358,-46.1455 2.2613243,2.2613243 0 0 0 50.695505,-49.080611 49.671112,49.671112 0 1 0 88.540376,-66.571615 Z m 0,94.826667 c -0.799253,0 -1.580444,-0.07902 -2.366151,-0.119662 A 21.923022,21.923022 0 0 1 65.962598,6.8061631 22.060747,22.060747 0 0 1 88.540376,-14.642726 26.576302,26.576302 0 0 0 115.63371,-40.607171 25.169707,25.169707 0 0 0 109.71833,-56.757055 45.139752,45.139752 0 0 1 88.540376,28.255052 Z",
    style: {
      fill: "#373737",
      strokeWidth: 2.25777769
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5070",
    className: "",
    "data-original": "#373737",
    d: "m 88.540376,41.801719 a 58.661583,58.661583 0 0 0 47.372694,-93.313956 l 2.89673,-2.894472 a 5.6670223,5.6670223 0 0 0 0,-7.999306 l -4.76391,-4.763912 a 5.6670223,5.6670223 0 0 0 -7.99931,0 l -2.89447,2.896729 A 58.399681,58.399681 0 0 0 97.571487,-74.907331 v -5.210951 a 4.5155556,4.5155556 0 0 0 4.515553,-4.515556 v -4.515555 a 4.5155556,4.5155556 0 0 0 -4.515553,-4.515556 H 79.509265 a 4.5155556,4.5155556 0 0 0 -4.515556,4.515556 v 4.515555 a 4.5155556,4.5155556 0 0 0 4.515556,4.515556 v 5.210951 a 58.399681,58.399681 0 0 0 -25.580623,10.634133 l -2.894471,-2.896729 a 5.6670223,5.6670223 0 0 0 -7.999307,0 l -4.763911,4.763912 a 5.6670223,5.6670223 0 0 0 0,7.999306 l 2.896729,2.894472 a 58.661583,58.661583 0 0 0 47.372694,93.313956 z m 0,-4.515556 A 54.186667,54.186667 0 1 1 142.72704,-16.900504 54.249885,54.249885 0 0 1 88.540376,37.286163 Z M 129.23908,-63.977429 a 1.1288889,1.1288889 0 0 1 1.61431,0 l 4.76391,4.763911 a 1.1288889,1.1288889 0 0 1 0,1.614312 l -2.53097,2.542257 a 59.483414,59.483414 0 0 0 -6.37822,-6.378222 z M 79.509265,-89.149393 h 18.062222 v 4.515555 H 79.509265 Z m 4.515555,9.031111 h 9.031112 v 4.707467 c -1.492392,-0.115147 -2.993814,-0.191912 -4.515556,-0.191912 -1.521742,0 -3.023164,0.07676 -4.515556,0.191912 z m -42.561369,22.519076 a 1.1288889,1.1288889 0 0 1 0,-1.614312 l 4.763911,-4.763911 a 1.1288889,1.1288889 0 0 1 1.614311,0 l 2.542258,2.530969 a 59.483414,59.483414 0 0 0 -6.389511,6.389511 z",
    style: {
      fill: "#373737",
      strokeWidth: 2.25777769
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5072",
    className: "",
    "data-original": "#373737",
    d: "m 97.571487,-40.607171 a 7.9022223,7.9022223 0 1 0 -7.902222,7.902223 7.9022223,7.9022223 0 0 0 7.902222,-7.902223 z m -11.288889,0 a 3.3866667,3.3866667 0 1 1 3.386667,3.386667 3.3866667,3.3866667 0 0 1 -3.386667,-3.386667 z",
    style: {
      fill: "#373737",
      strokeWidth: 2.25777769
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5074",
    className: "",
    "data-original": "#373737",
    d: "m 89.669265,-1.0960592 a 7.9022223,7.9022223 0 1 0 7.902222,7.9022223 7.9022223,7.9022223 0 0 0 -7.902222,-7.9022223 z m 0,11.2888892 A 3.3866667,3.3866667 0 1 1 93.055932,6.8061631 3.3866667,3.3866667 0 0 1 89.669265,10.19283 Z",
    style: {
      fill: "#373737",
      strokeWidth: 2.25777769
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.2a6a5c112f87ac7377c7c17063d4b9ff.svg";
export { ForwardRef as ReactComponent };